<template>
  <div>
   <el-container>
     <el-header style="border:1px solid #eee;background-color:#545c64;color:#fff;height:50px;">
      <span style="line-height:50px">菜鸟物流管理后台</span>
      </el-header>
     <el-container >
        <el-aside style="background-color:#545c64;height:100vh" >
            <el-menu 
                class="el-menu-vertical-demo"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b" :default-active="$route.path" router unique-opened >
                  <el-submenu index="1">
                    <template slot="title">
                    <i class="el-icon-menu"></i>
                    物流线路
                    </template>
                    <el-menu-item index="lineList">线路管理</el-menu-item>
                  </el-submenu>
                  <el-submenu index="2">
                    <template slot="title">
                    <i class="el-icon-menu"></i>
                    物流网点
                    </template>
                    <el-menu-item index="/networkList">网点管理</el-menu-item>
                  </el-submenu>
                  <el-submenu index="3">
                    <template slot="title">
                    <i class="el-icon-menu"></i>
                    积分商城
                    </template>
                    <el-menu-item index="/goodsList">商品列表</el-menu-item>
                     <el-menu-item index="/goodsOrderList">订单列表</el-menu-item>
                  </el-submenu>
                  <el-submenu index="4">
                    <template slot="title">
                    <i class="el-icon-menu"></i>
                    内容管理
                    </template>
                    <el-menu-item index="/articleList">文章管理</el-menu-item>
                  </el-submenu>
                  <el-submenu index="5">
                    <template slot="title">
                    <i class="el-icon-menu"></i>
                    免费市场
                    </template>
                    <el-menu-item index="/freeMarketList">市场管理</el-menu-item>
                  </el-submenu>
                  <el-submenu index="6">
                    <template slot="title">
                    <i class="el-icon-menu"></i>
                    招商加盟
                    </template>
                    <el-menu-item index="/joinUs">申请列表</el-menu-item>
                  </el-submenu>
                  <el-submenu index="7">
                    <template slot="title">
                    <i class="el-icon-menu"></i>
                    用户中心
                    </template>
                    <el-menu-item index="/userList">用户列表</el-menu-item>
                  </el-submenu>
                  <el-submenu index="8">
                    <template slot="title">
                    <i class="el-icon-menu"></i>
                    诚聘英才
                    </template>
                    <el-menu-item index="/employList">信息发布</el-menu-item>
                  </el-submenu>
              </el-menu>
        </el-aside>
        <el-main>
             <transition mode="out-in">
                <router-view/>
            </transition>
        </el-main>
     </el-container>

   </el-container>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>
<style>
  
</style>

